import React, { useState } from 'react';
import { QueryClient, QueryClientProvider, QueryCache } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import PropTypes from 'prop-types';
import config from '../../config';
import { Loading } from '../ui';

const QueryConfigProvider = (props) => {
  const [isRedirecting, setIsRedirecting] = useState(false);

  const queryClient = new QueryClient({
    queryCache: new QueryCache({
      onError: (error) => {
        // Don't redirect if the error is from the plus api
        if (error?.config?.url?.includes('/plus/')) {
          return;
        }

        //redirect to reauth if the user use a GET route without being authenticated
        if (error?.response?.status === 401 && error?.response?.config?.method === 'get') {
          queryClient.removeQueries();
          queryClient.clear();
          if (!isRedirecting) {
            setIsRedirecting(true);
            window.location.href = '/reauth';
          }
        }
      },
    }),
    defaultOptions: {
      queries: {
        staleTime: 60 * 1000, // 1min
        retry: (failureCount, error) => {
          const statusCode = error?.response?.status;
          if (statusCode === 404 || statusCode === 403 || statusCode === 401) {
            return false;
          }
          // Don't retry when running tests.
          if (config.appEnv === 'test') {
            return false;
          }
          return failureCount < 2;
        },
        refetchOnWindowFocus: false,
      },
    },
  });

  return isRedirecting ? (
    <Loading pageHeader={true} />
  ) : (
    <QueryClientProvider {...props} client={queryClient}>
      {props.children}
      <ReactQueryDevtools />
    </QueryClientProvider>
  );
};

QueryConfigProvider.propTypes = {
  children: PropTypes.object,
};

export default QueryConfigProvider;
